import { useEffect, useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { fetchConfigsQuery, fetchSelectedSitesQuery } from "../queries";
import { FinlandConfig, FinlandSiteServiceInfo, SelectedSite } from "../../types";

const useFinlandSiteMetricsDialog = ({ siteServiceInfos }: { siteServiceInfos: FinlandSiteServiceInfo }) => {
  const [configs, setConfigs] = useState<FinlandConfig[]>([]);
  const [selectedSites, setSelectedSites] = useState<SelectedSite[]>([]);

  const dataprovider = useDataProvider();
  const notify = useNotify();

  useEffect(() => {
    const loadDialogData = async () => {
      try {
        if (siteServiceInfos.group) {
          const nextConfigs = await fetchConfigsQuery(dataprovider, siteServiceInfos.group.code);
          setConfigs(nextConfigs);
        } else {
          setConfigs([]);
        }

        if (siteServiceInfos.selectedSitesIds) {
          const nextSelectedSites = await fetchSelectedSitesQuery(dataprovider, siteServiceInfos.selectedSitesIds);
          setSelectedSites(nextSelectedSites);
        } else {
          setSelectedSites([]);
        }
      } catch (e: unknown) {
        const errorMessage = e instanceof Error ? e.message : String(e);
        notify(`Failed to load Finland metrics dialog data: ${errorMessage}`, { type: "error" });
      }
    };

    void loadDialogData();
  }, [dataprovider, notify, siteServiceInfos.group, siteServiceInfos.selectedSitesIds]);

  return {
    configs,
    selectedSites,
  };
};

export default useFinlandSiteMetricsDialog;
